import styled from 'styled-components'

export const ActionsContainer = styled.div`
  display: grid;
  grid-gap: ${props => props.theme.spacing.sp16};
  grid-template-columns: 1fr 1fr;
  width: 100%;
  margin-top: ${props => props.theme.spacing.sp16};
`

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`
